import { useEffect, useState } from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableHeadCell,
  TableBodyCell,
  Button,
} from "../../../StyledComponents";
import { Div } from "../../Styles";
import {
  TxtSpan,
  NewTableHeadCell,
  AvatarFrame,
  AvatarTxt,
  NewActionButton,
} from "../styles";
import Loading from "../../../StyledComponents/Loading";
import axiosInst from "../../../../Config";
import { Decrypt_Value } from "../../../../MiddleWare/EncryptDecrypt";
import EmptyData from "../../../StyledComponents/EmptyData";

const SuperBillTable = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  let backurl = "";
  let firstDot = window.location.hostname.split(".");
  let DBhost;
  if (firstDot[0] !== "localhost") {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS.replace(
      "oemr",
      firstDot[0],
    );
  } else {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS;
  }
  if (
    firstDot[0] === "localhost" ||
    firstDot[0] === "test" ||
    firstDot[0] === "mumbai" ||
    firstDot[0] === "production" ||
    firstDot[0] === "ehr" ||
    firstDot[0] === "ehr1" ||
    firstDot[0] === "dev"
  ) {
    DBhost = "default";
  } else {
    DBhost = firstDot[0];
  }

  const File_URL = backurl + "/sites/" + DBhost + "/portal_statement_documents";

  useEffect(() => {
    axiosInst
      .get(`/vozoportal/getSuperBillList?pid=${Pat_ID}`)
      .then((res) => {
        const decryptedResponse = Decrypt_Value(res.data, "vozoportal");
        setLoading(false);
        setDocuments(decryptedResponse);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const Pat_ID =
    localStorage.getItem("PID") &&
    Decrypt_Value(localStorage.getItem("PID"), "vozoportal");

  const handleDownload = async (url, id) => {
    const file = url;
    const fileName = "SuperBill.pdf";
    // Create a link for download
    const link = document.createElement("a");
    link.href = file;
    link.download = fileName || "Superbill.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleView = (pdfBase64) => {
    if (!pdfBase64) {
      console.error("Invalid PDF data");
      return;
    }

    // Open Base64 PDF in a new tab
    const pdfWindow = window.open();
    pdfWindow.document.write(
      `<iframe width="100%" height="100%" src="${pdfBase64}"></iframe>`,
    );
  };

  return (
    <Div style={{ minHeight: "30vh" }}>
      {loading ? (
        <Loading height={40} />
      ) : (
        <Table>
          <TableHead>
            <TableRow
              display="grid"
              tempColumns="30% 30% 20% 20%"
              background="#F1F7FF"
            >
              <NewTableHeadCell padding="16px 20px">Provider</NewTableHeadCell>
              <NewTableHeadCell padding="16px 20px">Facility</NewTableHeadCell>
              <NewTableHeadCell padding="16px 20px">
                Generated On
              </NewTableHeadCell>
              <NewTableHeadCell textAlign="center" padding="16px 20px">
                Action
              </NewTableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {documents.some(
              (doc) =>
                doc &&
                (doc.provider_name ||
                  doc.facility_name ||
                  doc.document_date ||
                  doc.pdf_link),
            ) ? ( // ✅ Corrected conditional rendering
              documents.map((doc, index) => (
                <TableRow
                  key={index}
                  display="grid"
                  tempColumns="30% 30% 20% 20%"
                  alignItems="center"
                >
                  <TableBodyCell padding="16px 20px">
                    <Div display="flex" alignItems="center">
                      <AvatarFrame>
                        <AvatarTxt>
                          {doc?.provider_name
                            ? doc.provider_name.charAt(0)
                            : "P"}
                        </AvatarTxt>
                      </AvatarFrame>
                      <TxtSpan
                        fontWeight="500"
                        color="#1e293b"
                        title={doc?.provider_name}
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "block",
                          maxWidth: "180px",
                        }}
                      >
                        {doc?.provider_name || "-"}
                      </TxtSpan>
                    </Div>
                  </TableBodyCell>
                  <TableBodyCell padding="16px 20px">
                    <TxtSpan
                      color="#475569"
                      title={doc?.facility_name}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "block",
                        maxWidth: "180px", // adjust based on layout
                      }}
                    >
                      {doc?.facility_name || "-"}
                    </TxtSpan>
                  </TableBodyCell>
                  <TableBodyCell padding="16px 20px">
                    <TxtSpan color="#64748b">
                      {doc?.generatedDate
                        ? doc.generatedDate.split(" ")[0]
                        : "-"}
                    </TxtSpan>
                  </TableBodyCell>

                  <TableBodyCell padding="16px 0px">
                    <Div display="flex" gap="12px" justifyContent="center">
                      <NewActionButton
                        variant="outline"
                        onClick={() => handleDownload(doc.pdf_url, doc.id)}
                      >
                        Download
                      </NewActionButton>
                      <NewActionButton onClick={() => handleView(doc.pdf_url)}>
                        View
                      </NewActionButton>
                    </Div>
                  </TableBodyCell>
                </TableRow>
              ))
            ) : (
              // ✅ Show empty state if no data is available
              <TableRow>
                <TableBodyCell colSpan={5} textAlign="center">
                  <EmptyData />
                </TableBodyCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      )}
    </Div>
  );
};

export default SuperBillTable;
